<script setup>
import Loader from '@/components/Loader/Loader.vue';
import SportLiveTvState from '@/sport-live-tv/components/sport-live-tv-state.vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

const { t } = useSportLiveTvTranslation();
</script>

<template>
  <SportLiveTvState :title="t('loadingTitle')" :message="t('loadingMessage')">
    <template #icon>
      <div class="sport-live-tv-loading__spinner">
        <Loader />
      </div>
    </template>
  </SportLiveTvState>
</template>

<style lang="scss" scoped>
.sport-live-tv-loading__spinner {
  position: relative;
  width: 80px;
  height: 80px;
}
</style>
